import {UI, StyleSheet, styleRule, registerStyle} from "../../../../stem-core/src/ui/UI";
import {Messages} from "../../../Messages";
import {ExternalLink} from "../../../widget/ui/ExternalLink";


class TosMessageStyle extends StyleSheet {
    @styleRule
    tosMessage = {
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_SMALL,
        color: this.themeProps.MERCHANT_TEXT_SECONDARY_COLOR,
        lineHeight: 21,
        display: "inline-block",
        paddingTop: 12,
        marginTop: 4,
    };
}

@registerStyle(TosMessageStyle)
export class TosMessage extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            preMessage: "",
            showBorder: true,
            termsLink: "/terms",
            policyLink: "/privacy-policy",
        }
    };

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        if (this.options.showBorder) {
            attr.setStyle("borderTop", "0.5px solid " + this.styleSheet.themeProps.MERCHANT_FRAME_HEADER_BORDER_COLOR);
        }
    }

    render() {
        const {styleSheet} = this;
        return [
            <div className={styleSheet.tosMessage} testId="tosText">
                <span>{[this.options.preMessage, Messages.termsAndCoditions]}</span>
                <ExternalLink testId="signupTermsLink" href={this.options.termsLink} newTab noIcon label={Messages.terms} />
                {" "}and{" "}
                <ExternalLink testId="signupPolicyLink" href={this.options.policyLink} newTab noIcon label={Messages.policy} />
                .
            </div>,
        ];
    }
}
